export default {
    computed: {
        statusList () {
            return [
                {
                    label: "激活",
                    value: 1,
                    color: "success"
                },
                {
                    label: "取消",
                    value: 0,
                    color: "error"
                }
            ]
        },
        templateType () {
            return [
                {
                    label: "按组织设置",
                    value: 0
                },
                {
                    label: "按项目设置",
                    value: 1
                },
                {
                    label: "按ERP SKU设置",
                    value: 2
                }
            ]
        }
    }
}
